'use strict'

import React from 'react'
import { eventEmitter } from '../../../../../common/baseData'

function ProductButtons (props) {
  return (
    <>
      {
        props.AVAILABLE_STATE === 1 &&
        props.DISPLAY_PRICE.hasOwnProperty('PRICE') && parseInt(props.DISPLAY_PRICE.PRICE) > 0 ?
          <>
            {
              (props.WARRANTY_DATA.TYPE !== 2 ||
                (props.WARRANTY_DATA.TYPE === 2 && props.WARRANTY_DATA.RELATED_PRODUCTS_IN_BASKET)) ?
                <a href="#"
                   onClick={(e) => {
                     e.preventDefault()
                     if (!props.inBasket) props.onAddToBasket(e)
                     eventEmitter.emit('openSmallCart')
                   }}
                   className={`buy-btn_mini`}
                   style={{
                     background: props.BUTTON_COLOR_DATA && props.BUTTON_COLOR_DATA.length ? props.BUTTON_COLOR_DATA : '#6364ff'
                   }}>
                  {
                    props.inBasket ?
                      <>
                        <i data-show="in-basket" onClick={(e) => {
                          if (props.inBasket) eventEmitter.emit('openSmallCart')
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="27"
                               viewBox="-5 0 29 27" id="ic-in-basket" y="1324">
                            <path d="M1.479 11.404L7.11 15.56M17.377 1.528L7.194 15.585" fill="none"
                                  stroke="#FFF" strokeLinecap="square" strokeWidth="1.5"/>
                          </svg>
                        </i>
                        <span className="text-white text-[12px] h-full flex items-center">{props.getMessage('CT_BCI_TPL_IN_BASKET')}</span>
                      </> :
                      <>
                        <i data-show="basket">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23"
                               viewBox="-5 0 33 33" id="ic-basket" y="553">
                            <g fill="none" fillRule="evenodd"
                               stroke={props.BUTTON_COLOR_DATA && props.BUTTON_COLOR_DATA.length ? props.BUTTON_COLOR_DATA : '#fff'}
                               strokeWidth="1.5"
                               opacity=".6"
                               transform="translate(.414 1.275)">
                              <path d="M.583.022h3.835l2.356 13.925h11.101l3.452-9.397H5.618"/>
                              <ellipse cx="7.365" cy="18.686" rx="1.758" ry="1.756"/>
                              <ellipse cx="16.706" cy="18.686" rx="1.758" ry="1.756"/>
                            </g>
                          </svg>
                        </i>
                        <span className="text-white text-[12px] h-full flex items-center">{props.getMessage('CT_BCS_TPL_MESS_BTN_BUY')}</span>
                      </>
                  }
                </a> :
                <></>
            }
          </> :
          <></>
      }
      {
        props.AVAILABLE_STATE === 2 || props.AVAILABLE_STATE === 3 ?
          <div className="btn-holder">
            <a href="#" className="btn btn-block btn-border phone:min-w-[140px]" onClick={event => {
              event.preventDefault()
              props.AVAILABLE_STATE === 2 ?
                eventEmitter.emit('preOrder', { productId: props.ID }) :
                eventEmitter.emit('reportAvailability', { productId: props.ID })
            }}>
                  <span onClick={event => {
                    event.preventDefault()
                    props.AVAILABLE_STATE === 2 ?
                      eventEmitter.emit('preOrder', { productId: props.ID }) :
                      eventEmitter.emit('reportAvailability', { productId: props.ID })
                  }}>
                    {
                      props.AVAILABLE_STATE === 2 ?
                        props.getMessage('CT_BCI_TPL_PRE_ORDER') :
                        props.getMessage('CT_BCI_TPL_BUTTON_REPORT')
                    }
                  </span>
            </a>
          </div> :
          <></>
      }
      {
        props.AVAILABLE_STATE === 4 && props.hasOwnProperty('NEW_MODELS_CATEGORY') ?
          <a href={Array.isArray(props.NEW_MODELS_CATEGORY) ?
            props.NEW_MODELS_CATEGORY.SECTION_PAGE_URL : props.NEW_MODELS_CATEGORY}
             className="link">
            {props.getMessage('CT_BCI_TPL_WATCH_NEW_MODELS')} {Array.isArray(props.NEW_MODELS_CATEGORY) ? props.NEW_MODELS_CATEGORY.NAME : ''}
          </a> :
          <></>
      }
    </>
  )
}

export default ProductButtons